import type { Selection } from '@atlaskit/editor-prosemirror/state';
import { UNSAFE_expValNoExposure } from '@atlaskit/platform-feature-experiments/unsafe-exp-val-no-exposure';
import { publish } from '@atlaskit/rovo-triggers/main';
import { Topics } from '@atlaskit/rovo-triggers/types';

// Tells the list of Rovo Remix options whether the user is remixing the whole page or only the part
// of the page they currently have selected, so that it can offer the appropriate options.
export const publishEditorRemixPreset = (selection: Selection): void => {
	if (
		UNSAFE_expValNoExposure('cc-ce-maui-remix-menu-multivariant', 'cohort', 'control') !==
		'variant2'
	) {
		return;
	}

	const remixPreset = selection.empty ? 'page' : 'selection';
	publish(Topics.ROVO_REMIX, {
		type: 'update-rovo-remix-preset',
		source: 'editor-selection',
		openChat: false,
		data: { remixConsumer: 'editor', remixPreset },
	});
};
